module.exports = __webpack_public_path__ + "static/media/ZvukOK.07d78c6c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/sounds/ZvukOK.mp3
// module id = 806
// module chunks = 0